import { createContext, type PropsWithChildren, useContext } from 'react'

export interface EngagementInsightsData {
  [key: string]: any
}

const EngagementInsightsContext = createContext<EngagementInsightsData | null>(null)

export const EngagementInsightsProvider = ({
  children,
  data,
}: PropsWithChildren<{ data: EngagementInsightsData }>) => {
  return (
    <EngagementInsightsContext.Provider value={data}>{children}</EngagementInsightsContext.Provider>
  )
}

export const useEngagementInsightsData = () => {
  const data = useContext(EngagementInsightsContext)

  if (!data) {
    throw new Error('Engagement context has no data')
  }

  return data
}
